module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.ttf?0e4e0b3da55fa7faa77b4c2d978008dd";